export class CrfSubmittedModel{
    "patientId":String;
    "sectionId":Number;
    "userId":Number;
}